import { type RPPDomain } from '@retailer-platform/dashboard/core'
import {
  NavItem,
  AdminNavEntryPoint,
  AdminNavEntryPointV2,
} from '@retailer-platform/dashboard/routing'
import { pageBuilderViewAccessControl } from './access-control/landingAccess.configuration'
import { landingRouter } from './routing/landingRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import ES_ES from './translations/es-ES.json'
import FR_FR from './translations/fr-FR.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'landing',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'landing-dashboard-tool',
  },
  routes,
  translations: { EN_US, ES_ES, FR_FR },
  routers: {
    admin: [landingRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachTo: AdminNavEntryPoint.LandingPageSystem,
      attachToV2: AdminNavEntryPointV2.Marketing,
      subNavItems: [
        {
          route: 'landing-content-pages-dashboard',
          labelId: 'landingDomain.landingPageBuilder',
          accessControl: pageBuilderViewAccessControl,
          positionNavV2: 2,
          inToolPermissions: [
            {
              slug: Permission.LandingPageBuilderModify,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.LandingPageBuilderModify,
            },
          ],
        },
      ],
    },
  ],
}

export default definition
